
angular.module('bmsApp.directives')
		.directive('loadingContainer', function () {
			return {
				restrict: 'E',
				replace: true,
				require: "^ngModel",
				scope: {
					ngModel: '=',
					type: '@'
				},
				template: '<div class="loading animations-disabled {{ type }}" ng-show="ngModel"><img class="loading-image" ng-src="images/shared/loading-{{ type }}.gif"><div class="loading-text" ng-show="type == \'large\' || type == \'medium\'">Loading</div></div> ',
				link: function (scope, element, attrs) {
					scope.type = (!angular.isUndefined(attrs.type)) ? attrs.type : "small";
				}
			};
		});

